import React from 'react'
import { Deposit } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { FormLabels } from 'src/components'

const DepositReferenceColumn = ({ deposit }: { deposit: Deposit }) => {
  const { t } = useTranslation()
  const kindLabel = {
    card: t('Payment.Card'),
    credit_card: t('Payment.CreditCard'),
    bank: t('Payment.Bank'),
  }[deposit?.kind] || t('Payment.Bank')

  return (
    <FormLabels
      title={`#${deposit.internal_reference}`}
      subtitle={kindLabel}
    />
  )
}

export default DepositReferenceColumn
